import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class ProfileService {
    constructor(private http: HttpClient) {}

    findCurrent(): Observable<any> {
        return this.http.get<any>('/api/profile');
    }

    saveBioForCurrent(bio: string) {
        return this.http.put('/api/profile/bio', bio);
    }

    resetPictureForCurrent() {
        return this.http.delete('/api/profile/picture');
    }

    uploadPictureFile(file) {
        let formData = new FormData();
        formData.append('file', file);
        return this.http.post('/api/profile/picture', formData);
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/profile/profile.service.ts